<template>
  <div>
    <b-table
      hover
      :items="items"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BSpinner, BTable } from 'bootstrap-vue'
import * as Services from './services'

export default {
  components: {
    BSpinner,
    BCardCode,
    BTable,
  },
  setup() {
    const { MostViewedProduct } = Services
    const { data: productData } = MostViewedProduct()
    return {
      productData,
      loading : true
    }
  },
  computed: {
    items() {
      let items = []
      for (let index = 0; index < 5; index++) {
        items.push({
          most_viewed_product: this.productData[index] ? this.productData[index].product_details.PRODUCT : '-',
          views: !this.productData[index] ?  '-' : this.productData[index].count ? this.productData[index].count : this.productData[index].count,
        })
      }
      return items
    }
  },
  watch: {
    productData: function (newVal, oldVal) {
      this.loading = false
    }
  }
}
</script>